import { useState } from "react";
import { Plus, Minus } from "lucide-react";
import { Overline, Reveal, Section } from "./shared";

export const PageHero = ({ overline, title, subtitle, children }) => (
  <Section className="pt-36 pb-16 lg:pt-44 lg:pb-20" grid>
    <div className="max-w-4xl">
      <Reveal><Overline>{overline}</Overline></Reveal>
      <Reveal delay={80}>
        <h1 className="mt-7 text-4xl lg:text-6xl tracking-tighter leading-[0.98] font-medium text-ink">{title}</h1>
      </Reveal>
      {subtitle && (
        <Reveal delay={160}>
          <p className="mt-7 text-base lg:text-lg text-dark-gray leading-relaxed max-w-2xl">{subtitle}</p>
        </Reveal>
      )}
      {children}
    </div>
  </Section>
);

export const FAQ = ({ items, dark = false }) => {
  const [open, setOpen] = useState(0);
  return (
    <div className="border-t border-silver/50">
      {items.map((it, i) => (
        <div key={i} className="border-b border-silver/50" data-testid={`faq-item-${i}`}>
          <button
            onClick={() => setOpen(open === i ? -1 : i)}
            className="w-full flex items-center justify-between gap-6 py-6 text-left group"
            data-testid={`faq-toggle-${i}`}
          >
            <span className={`text-lg lg:text-xl ${dark ? "text-white" : "text-ink"} group-hover:text-blue-gray transition-colors`}>{it.q}</span>
            <span className="shrink-0 text-acid-dark">{open === i ? <Minus size={20} /> : <Plus size={20} />}</span>
          </button>
          {open === i && (
            <p className={`pb-7 text-sm leading-relaxed max-w-3xl ${dark ? "text-white/60" : "text-dark-gray"}`}>{it.a}</p>
          )}
        </div>
      ))}
    </div>
  );
};

export const StepList = ({ steps }) => (
  <div className="grid gap-px bg-silver/40 border border-silver/40 sm:grid-cols-2 lg:grid-cols-3">
    {steps.map((s, i) => (
      <Reveal key={s.t} delay={i * 80}>
        <div className="bg-white p-8 h-full">
          <span className="font-mono-sci text-xs text-acid-dark">{String(i + 1).padStart(2, "0")}</span>
          <h3 className="mt-5 text-xl text-ink">{s.t}</h3>
          {s.d && <p className="mt-2 text-sm text-dark-gray leading-relaxed">{s.d}</p>}
        </div>
      </Reveal>
    ))}
  </div>
);
